// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"78e144ac","453":"af205ec6"}[chunkId] + ".chunk.js";
};